var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4375 9.0625C13.9453 9.0625 14.375 9.49219 14.375 10C14.375 10.5469 13.9453 10.9375 13.4375 10.9375H6.5625C6.01562 10.9375 5.625 10.5469 5.625 10C5.625 9.49219 6.01562 9.0625 6.5625 9.0625H13.4375ZM1.25 3.75C1.25 2.38281 2.34375 1.25 3.75 1.25H16.25C17.6172 1.25 18.75 2.38281 18.75 3.75V16.25C18.75 17.6562 17.6172 18.75 16.25 18.75H3.75C2.34375 18.75 1.25 17.6562 1.25 16.25V3.75ZM3.125 3.75V16.25C3.125 16.6016 3.39844 16.875 3.75 16.875H16.25C16.5625 16.875 16.875 16.6016 16.875 16.25V3.75C16.875 3.4375 16.5625 3.125 16.25 3.125H3.75C3.39844 3.125 3.125 3.4375 3.125 3.75Z",
    fill: "#8A0538"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLess);
export default __webpack_public_path__ + "static/media/Less.b109dcf2ee1d2d96be8b965a3b5b26d5.svg";
export { ForwardRef as ReactComponent };